<template>
<div>
          <!-- Header: Personal Info -->
          <div class="d-flex">
            <feather-icon
              icon="UserIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              Personal Information
            </h4>
          </div>

          <!-- Form: Personal Info Form -->
          <b-form class="mt-1">
            <b-row>

              <!-- Field: Mobile -->
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Code"
                  label-for="member_code"
                >
                  <b-form-input
                    id="member_code"
                    v-model="userData.member_code"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Chinese Name"
                  label-for="zh_name"
                >
                  <b-form-input
                    id="zh_name"
                    v-model="userData.zh_name"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="English Name"
                  label-for="en_name"
                >
                  <b-form-input
                    id="en_name"
                    v-model="userData.en_name"
                  />
                </b-form-group>
              </b-col>



              <b-col
          cols="12"
          md="6"
          lg="4"
          v-if="$can('read', 'staff')"
        >
          <b-form-group
            label="Date Of Birth"
            label-for="birth-date"
          >
            <flat-pickr
              v-model="userData.birth"
              class="form-control"
              :config="{ dateFormat: 'Y-m-d'}"
              placeholder="YYYY-MM-DD"
            />
          </b-form-group>
        </b-col>



              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="E-Mail"
                  label-for="email"
                >
                  <b-form-input
                    id="email"
                    v-model="userData.email"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Mobile"
                  label-for="mobile"
                >
                  <b-form-input
                    id="mobile"
                    v-model="userData.mobile"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Address"
                  label-for="address"
                >
                  <b-form-input
                    id="address"
                    v-model="userData.address"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
                 v-if="$can('read', 'staff')"
              >
                <b-form-group
                  label="Identity Number"
                  label-for="identity_number"
                >
                  <b-form-input
                    id="identity_number"
                    v-model="userData.identity_card"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Gender"
                  label-for="gender"
                >
                  <v-select
                    v-model="userData.gender"

                    :options="genderOptions"
                    :clearable="false"
                    input-id="gender"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Created at"
                  label-for="created_at"
                >
                  <b-form-input
                    id="created_at"
                    v-model="userData.created_at"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
                v-if="$can('read', 'staff')"
              >
                <b-form-group
                  label="Personal Trainer"
                  label-for="Personal Trainer"

                >
                  <v-select
                    v-model="userData.user_id"
                    :reduce="ans => ans.value"
                    :options="staffOptions"
                    :clearable="true"

                    multiple
                    input-id="user_id"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Status"
                  label-for="status"
                >
                  <v-select
                    v-model="userData.status"
:reduce="ans => ans.value"
                    :options="statusOptions"
                    :clearable="false"
                    input-id="status"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Remarks"
                  label-for="remarks"
                >
                 <b-form-textarea
                    id="remarks"
                    v-model="userData.remarks"
                  />
                </b-form-group>
              </b-col>


            </b-row>

            <b-row class="mt-2">
              <b-col>
                <b-button
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="save_member"
                 v-if="$can('read', 'staff')"
                >
                  Save Changes
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  :to="{ name: 'member-list' }"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
        </template>



<script>
import {
   BFormTextarea, BCardText, BAlert, BLink, BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'

export default {
  components: {
    ToastificationContent,
     BFormTextarea,
     BCardText,
    vSelect,
    flatPickr,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
  data() {
    return {
      centerOptions: [],
      staffOptions: [],
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      statusOptions: [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Disable', value: 'DISABLED' },
        { label: 'Deleted', value: 'DELETED' },
      ],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],

    }
  },
  created() {
    this.get_member_data()
    this.get_center_data()
    this.get_staff_list()
  },
  methods: {
    get_staff_list() {
      this.$http.get('https://valleyfitstudio.gfs.hk/api/v1/pro/staffs/select/')
        .then(res => {
          this.staffOptions = res.data
        })
    },
    save_member() {
      this.$http.post(`https://valleyfitstudio.gfs.hk/api/v1/pro/member/${this.userData.member_id}/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'XIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    get_center_data() {
      this.$http.get('https://valleyfitstudio.gfs.hk/api/v1/pro/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_member_data() {
      this.$http.get(`https://valleyfitstudio.gfs.hk/api/v1/pro/member/${router.currentRoute.params.id}/`)
        .then(res => {
          this.userData = res.data
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
